import { AspectRatio } from 'components/AspectRatio'
import { Caption, Text, Title } from 'components/Typography'
import Link from 'next/link'
import { PrimaryLink } from 'components/Link'
import styled from '@emotion/styled'
import { useWindowSize } from 'utils/hooks'
import { BREAKPOINTS } from 'utils/styled'

export function AboutTeamPerson(props: {
  name?: string
  photo?: string
  singlePhotoSrc?: string
  position?: string
  className?: string
}) {
  const { isDesktop } = useWindowSize()

  const imageSources = props.singlePhotoSrc
    ? { src: props.singlePhotoSrc }
    : props.photo
    ? {
        src: `/images/team/${props.photo}.png`,
        srcSet: `/images/team/${props.photo}.png 1x,
                 /images/team/${props.photo}@2x.png 2x`,
      }
    : null
  return (
    <SAboutTeamPerson>
      <AspectRatio ratio={1}>
        {imageSources && <SImage alt={props.name} {...imageSources} />}
      </AspectRatio>

      <SAboutTeamPersonText>
        {isDesktop ? (
          <>
            <Caption css={{ color: 'var(--c-blue500)' }}>{props.position}</Caption>
            <Title variant={'h7'} as="h6">
              {props.name}
            </Title>
          </>
        ) : (
          <>
            <Text variant="labelSmall" css={{ color: 'var(--c-blue500)' }}>
              {props.position}
            </Text>
            <Text variant="bodyBold" css={{ color: 'black' }}>
              {props.name}
            </Text>
          </>
        )}
      </SAboutTeamPersonText>
    </SAboutTeamPerson>
  )
}

export function InvestorLink(props: { href: string; name: string }) {
  return (
    <Link href={props.href} passHref legacyBehavior>
      <PrimaryLink>{props.name}</PrimaryLink>
    </Link>
  )
}

export function InvestorLinkUsingChildren(props: { href: string; children: string }) {
  return <InvestorLink href={props.href} name={props.children} />
}

const SAboutTeamPerson = styled.div``
const SAboutTeamPersonText = styled.div`
  min-height: 4.875rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @media ${BREAKPOINTS.MD.max} {
    min-height: 3rem;
  }
`

const SImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  transition: 0.2s filter ease;
  &:hover {
    filter: none;
  }
`
